
import { Link } from "react-router-dom";
import { AuthForm } from "@/components/auth/AuthForm";
import { Button } from "@/components/ui/button";
import { House } from "lucide-react";

const Auth = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8 relative">
      <Link to="/" className="absolute top-4 left-4">
        <Button variant="outline" className="gap-2">
          <House size={20} />
          Beranda
        </Button>
      </Link>
      
      <div className="w-full max-w-md mx-auto">
        <div className="flex justify-center mb-10">
          <img 
            src="https://idn-static-assets.s3.ap-southeast-1.amazonaws.com/subscription/infra_logo.png" 
            alt="Infra Logo" 
            className="h-32 object-contain" 
          />
        </div>
        
        <AuthForm />
      </div>
    </div>
  );
};

export default Auth;
